import { MdOutlineLocationOn, MdOutlineMail } from 'react-icons/md';
import logo from '../Assets/Icons/logo-footer.svg';
import { Link } from 'react-router-dom';
import playStore from '../Assets/Image/PlayStore.png';
import appleStore from '../Assets/Image/AppleStore.png';
import { SlSocialLinkedin } from 'react-icons/sl';
import { SiInstagram } from 'react-icons/si';
import { FiFacebook } from 'react-icons/fi';
import { TfiTwitter } from 'react-icons/tfi';

const footerData = [
  {
    id: 1,
    title: 'Products',
    children: [
      {
        id: 1,
        name: 'Exchange',
        url: 'http://loyaltyview.com/',
      },
      {
        id: 2,
        name: 'Loyalty View',
        url: 'http://loyaltyview.com/',
      },
      {
        id: 3,
        name: 'Secure View',
        url: 'https://mysecureview.ng/',
      },
      {
        id: 4,
        name: 'Kiddy View',
        url: 'https://kidyview.com/',
      },
    ],
  },
  {
    id: 2,
    title: 'Company',
    children: [
      {
        id: 1,
        name: 'About Us',
        url: '/about',
      },
      {
        id: 2,
        name: 'News',
        url: '/fxnews',
      },
      {
        id: 3,
        name: 'Terms and Conditions',
        url: '/terms-and-conditions',
      },
      {
        id: 4,
        name: 'Contact Us',
        url: '/contactus',
      },
    ],
  },
  {
    id: 3,
    title: 'Support',
    children: [
      {
        id: 1,
        name: 'FAQs',
        url: '/faqs',
      },
    ],
  },
];

export default function Footer() {
  return (
    <footer className='bg-[#1D1B35] text-white'>
      <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-[2fr_1fr_1fr_1fr_1fr] gap-4 gap-y-10 lg:gap-10 px-6 sm:px-10 md:px-20 max-w-[1440px] mx-auto mt-8 md:mt-24 font-pin py-20 '>
        <div className='flex flex-col gap-8 col-span-2 md:col-span-4 w-full md:w-3/4 lg:w-full lg:col-span-1'>
          <div className='shrink-0'>
            <img src={logo} alt='footer-logo' />
          </div>
          <ul className='flex flex-col gap-8'>
            <li className='flex gap-4 md:gap-5'>
              <MdOutlineLocationOn className='shrink-0' />
              <hgroup className='flex flex-col gap-4 md:gap-5 text-base font-normal leading-6 md:leading-8'>
                <span>
                  5B, Ladipo Omotesho Street, Lekki phase 1, Lagos, Nigeria.
                </span>
                <span>
                  71-75 Shelton Street, Covent Garden, London, WC2H 9JQ, United
                  Kingdom
                </span>
              </hgroup>
            </li>

            <li className='flex gap-4 md:gap-5'>
              <MdOutlineMail className='shrink-0' />
              <hgroup className='flex flex-col gap-4 md:gap-5 text-base font-normal leading-6 md:leading-8'>
                <span>hello@loyaltyview.com</span>
                <span>support@loyaltyview.com</span>
              </hgroup>
            </li>
          </ul>
        </div>
        {footerData.map((data) => (
          <div key={data.id} className='flex flex-col gap-8'>
            <h6 className='font-pin text-2xl font-medium leading-6 md:leading-8'>
              {data.title}
            </h6>
            <ul className='flex flex-col gap-4 md:gap-5'>
              {data.children.map((link) => (
                <li
                  key={link.id}
                  className='text-base font-normal leading-6 md:leading-8 hover:text-b-mc'
                >
                  <Link to={link.url}>{link.name}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className='flex flex-col gap-3'>
          <Link to='#'>
            <img src={playStore} alt='playStore' />
          </Link>
          <Link to='#'>
            <img src={appleStore} alt='appStore' />
          </Link>
        </div>

        <div className='flex flex-col gap-1 col-span-2 md:col-span-4'>
          <hgroup className='flex gap-4 md:gap-5'>
            <Link to='#'>
              <SlSocialLinkedin />
            </Link>
            <Link to='#'>
              <FiFacebook />
            </Link>
            <Link to='#'>
              <TfiTwitter />
            </Link>
            <Link to='#'>
              <SiInstagram />
            </Link>
          </hgroup>
          <p>Copyright &copy; {new Date().getFullYear()} Loyalty View </p>
        </div>
      </div>
    </footer>
  );
}
